<template>
<div>
    <v-row class="justify-center">
        <v-col cols="12" sm="8" md="6">
            <v-card outlined>
                <div class="d-flex justify-center text-center white--text body-2 font-weight-medium info py-3">
                    <span>Name</span> 
                </div>
                <v-card-text class="pa-6">
                    
                    <div class="d-flex justify-center text-center title font-weight-regular black--text">
                        {{user.name}}
                    </div>
                    <div class="d-flex justify-center mt-4">
                        <v-btn depressed large class="accent" @click="showDiag=true">Edit name</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

    <DiagName 
        :model="showDiag"
        @cancel="showDiag=false"
        @changed="changed" />
</div>
</template>

<script>
import DiagName from '@/components/core/dialogs/DiagName'
import Sign from '@/firebase/sign'

export default {
    data: () => ({
        showDiag: false
    }),
    components: {
        DiagName
    },
    methods: {
        changed() {
            Sign.reInitUser(this.user.uid);
            this.showDiag = false;
        }
    }
}
</script>